import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DoctorListRes;
export const DoctorListTodo = createAsyncThunk('DoctorList', async (data) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin/doctor',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token')},
            params:{
                "company_id":localStorage.getItem('companyId')
            },
        })
        return DoctorListRes = res.data

    } catch (error) {
        return DoctorListRes = error.response.data
    }
});

const DoctorListSlice = createSlice({
    name: 'DoctorList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(DoctorListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(DoctorListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default DoctorListSlice.reducer; 